import { Button, Input, Modal, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'

import { getUserId } from '../../helpers/auth'

import Loader from '../../pages/pages/loader'
import {
  useCreateIgnoreDomainMutation,
  useUpdateIgnoreDomainByIdMutation
} from '../../redux/apis/domainsManagement/ignore/dMDomainsIgnoreApiSlice'

const EditCreateDomainIframeModal = ({
  iframe,
  open,
  setOpen,
  isEdit = false,
  setHolder,
  setIsEdit
}) => {
  const [create, { isLoading, isSuccess, error }] =
    useCreateIgnoreDomainMutation()
  const [
    update,
    { isLoading: updateLoading, isSuccess: updateSuccess, error: updateError }
  ] = useUpdateIgnoreDomainByIdMutation()

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      domain: iframe?.domain || '',
      is_active: isEdit ? (iframe?.is_active ? true : false) : true,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      domain: Yup.string().required('Please Enter Campaign Keyword '),
      is_active: Yup.boolean().required('Please Select Campaign Status')
    }),

    onSubmit: async values => {
      try {
        if (isEdit) {
          await update({ id: iframe?.id, body: values }).unwrap()
        } else {
          await create(values)
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
  const handleErrors = (err) => {
    if (err?.data?.errors) {
      const errorMessages = Object.values(err.data.errors).flat();
      errorMessages.forEach((message) => {
        toast.error(message);
      });
    } else if (err?.data?.message) {
      toast.error(err.data.message);
    }
  };

  if (error) {
    handleErrors(error);
  } else if (updateError) {
    handleErrors(updateError);
  }
}, [error, updateError]);


  useEffect(() => {
    if (isSuccess) {
      toast.success('Domain Iframe Added!')
      setOpen(false)
      validation.resetForm()
    } else if (updateSuccess) {
      toast.success('Domain Iframe Updated!')
      setOpen(false)
      validation.resetForm()
    }
  }, [isSuccess, updateSuccess])
  return (
    <>
      <Loader isLoading={isLoading || updateLoading} />
      <div className='flex w-full justify-end'>
        <button
          className='btn btn-outline-theme mb-4'
          onClick={() => {
            setHolder()
            setIsEdit(false)
            setOpen(true)
          }}
        >
          Create New Ignore Domain
        </button>
      </div>
      <Modal
        open={open}
        title={isEdit ? 'Edit Ignore Domain' : 'Create New Ignore Domain'}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key='back' onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            onClick={() => {
              if (Object.keys(validation.errors).length !== 0) {
                Object.keys(validation.errors).map(key => {
                  toast.error(validation.errors[key])
                })
                return
              }
              validation.handleSubmit()
            }}
          >
            Submit
          </Button>
        ]}
      >
        <div className='gap-8 '>
          <div className=' mb-3 flex-1'>
            <label className="form-label">Ignore Domain Name</label>
            <Input
              type='text'
              name='domain'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.domain}
            />
            {validation.touched.domain && validation.errors.domain ? (
              <p className='text-danger'>{validation.errors.domain}</p>
            ) : null}
          </div>

          <div className=' mb-3 flex-1'>
            <label>Ignore Domain Status</label>
            <br />
            <Select
              className={''}
              name='is_active'
              style={{
                width: '100%'
              }}
              defaultValue={validation?.values?.is_active}
              value={validation?.values?.is_active}
              onChange={e => validation.setFieldValue('is_active', e)}
              onBlur={validation.handleBlur}
              options={[
                {
                  label: 'Active',
                  value: true
                },
                {
                  label: 'Inactive',
                  value: false
                }
              ]}
            />
            {validation.touched.status && validation.errors.status ? (
              <p className='text-danger'>{validation.errors.status}</p>
            ) : null}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default EditCreateDomainIframeModal
